import { Component, Inject, Input, OnInit } from '@angular/core';
import * as fromGraphQl from './graphql';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { Form } from '../../entities/form/form';
import { FormVariant } from '../../entities/form-variant/form-variant';
import { FormVariantsService } from '../../services/form-variants/form-variants.service';
import { LoadingService } from '../../services/loading.service';
import { Container } from '../../containers/container';
import { ConfirmDialogEventType, ConfirmDialogSeverity } from '../confirmDialog/confirmDialogComponent';
import { ConfirmDialogService } from '../confirmDialog/confirmDialogService';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-forms-list',
  templateUrl: './forms-list.component.html',
  styleUrls: ['./forms-list.component.scss']
})
export class FormsListComponent extends Container<fromGraphQl.FormsQueryResponse>
implements OnInit{
  public forms: Form[];
  @Input() withMainHeadline = true;

  constructor(
    loadingService: LoadingService,
    apollo: Apollo,
    private confirmDialogService: ConfirmDialogService,
    private router: Router,
    private formVariantsService: FormVariantsService,
    @Inject('env') environment : any
  ) {
    super(apollo, loadingService, fromGraphQl.FORMS_QUERY, environment);
  }

  ngOnInit(): void {
    this.subscribeToQuery();
    }

  handleSubscriptionResult(data: fromGraphQl.FormsQueryResponse): void {
    this.loadingService.setLoading(false);
    if (data) {
      this.queryRef.stopPolling();
      this.forms = Form.createForms(data.forms);
    }
  }

  createFormVariant(formKey: string) {
    console.log('to create');
    // TODO
    this.router.navigate(['./settings/forms/'+formKey+'/create/']);
  }

  confirmDialog(variant: FormVariant): void {
    const message = 'Möchtest Du die Vorlage (' + variant.name +') wirklich löschen?';
    const dialogRef = this.confirmDialogService.open({
      message: message,
      header: 'Vorlage löschen',
      severity: ConfirmDialogSeverity.WARN,
      confirmLabel: 'Löschen'
    });

    dialogRef.onClose.subscribe((result: ConfirmDialogEventType) => {
      if (result === ConfirmDialogEventType.CONFIRM) {
        this.loadingService.setLoading(true);
        this.deleteVariant(variant.id);
      }
    });
  }

  deleteVariant(id: string) {
    // TODO
    this.formVariantsService.deleteFormVariant(
      id,
      this.returnCallback(this.router)
    );
  }

  returnCallback(router: Router): void {
    setTimeout(() => {
      this.loadingService.setLoading(false);
      this.queryRef.refetch();
    }, 500);
  }
  viewFormVariant(formKey: string, id: string) {
    // TODO
    if (id) {
      this.router.navigate(['./settings/forms/' +formKey + '/' + id]);
    }
  }

}
